var render, staticRenderFns
import script from "./ToolbarBtn.vue?vue&type=script&lang=js&"
export * from "./ToolbarBtn.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('151beb9d')) {
      api.createRecord('151beb9d', component.options)
    } else {
      api.reload('151beb9d', component.options)
    }
    
  }
}
component.options.__file = "src/components/GroupTeams/Common/ToolbarBtn.vue"
export default component.exports